module.exports = __webpack_public_path__ + "static/media/sample-vaccination-card.36239fa0.jpg";